import React from 'react';
import PropTypes from 'prop-types';

import SEO from '../components/Core/SEO';
import Redirect from '../components/Core/Redirect';

// TODO: look into serving the proper page via
// nginx instead of loading the index page and
// then redirecting afterwards, as this makes our
// page look like it has an empty body to Google

const IndexPage = ({ location }) => {
  return (
    <>
      <SEO title="Home" />
      <Redirect
        origin={location}
        location={location.pathname}
        getLangPreference
      />
    </>
  );
};

IndexPage.propTypes = {
  location: PropTypes.shape().isRequired,
};

export default IndexPage;
